import React, { useState, useRef, useEffect } from 'react';
import './header.css';
import logo from '../../assets/images/logo.png';

import { Link, useNavigate } from "react-router-dom";
import Dropdown from '../layout/Dropdown';
import { FiSearch } from 'react-icons/fi';
import { AiOutlineSearch } from 'react-icons/ai';
import { BsList } from 'react-icons/bs';
import HCaptcha from "@hcaptcha/react-hcaptcha";
import validator from "validator";
import { Backdrop, CircularProgress } from "@mui/material";
import { Modal, Button } from "react-bootstrap";
import Swal from "sweetalert2";
import qs from "qs";

const Header = () => {

    const [isCategory, setCategory] = useState([]);
    const [isCollection, setCollection] = useState([]);
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [isQuote, setQuote] = useState("");
    const [isShow, setShow] = useState(false);
    const [isSearch, setSearch] = useState("");
    const [isOption, setOption] = useState([]);
    const [isShowDiv, setShowDiv] = useState(false);
    const [isMenu, setIsMenu] = useState(false);
    const [isShowModal, setShowModal] = useState(false);
    const [isEmailError, setIsEmailError] = useState(false);
    const [isClicked, setIsClicked] = useState(false);
    const [isCaptchaExpired, setIsCaptchaExpired] = useState(false);
    const [token, setToken] = useState(null);
    const [isOpenBackdrop, setIsOpenBackdrop] = useState(false);
    const captchaRef = useRef(null);


    useEffect(() => {


        fetch(`/api/graphql/get-categories-name`,{
            method: 'POST',
                headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => {
                return response.json();
            })
            .then((res) => {
                let category_uniques = [];
                let categories_data = res.data.categories.data.filter((element) => {
                    const isDuplicate = category_uniques.includes(element.attributes.name);
                    if (!isDuplicate) {
                        category_uniques.push(element.attributes.name);
                        return true;
                    }
                    return false;
                });

                setCategory(categories_data);
            });

        fetch(`/api/graphql/get-collections-name`,{
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => {
                return response.json();
            })
            .then((res) => {
                let collection_uniqeus = [];
                let collections_data = res.data.collections.data.filter((element) => {
                    const isDuplicate = collection_uniqeus.includes(element.attributes.name);
                    if (!isDuplicate) {
                        collection_uniqeus.push(element.attributes.name);
                        return true;
                    }
                    return false;
                });

                setCollection(collections_data);
            });

    }, []);


    const navItems = [
        {
            title: 'Products',
            children: isCategory,
            type: 'dropdown'
        },
        {
            title: 'Custom Fabrication',
            url: '/custom-fabrication',
            type: 'single'
        },
        {
            title: 'Custom Work',
            url: '/custom-work',
            type: 'single'
        },
        {
            title: 'Resources',
            children: [
                'All Downloads', 'Case Studies', 'Warranties / Terms & Conditions'
            ],
            type: 'dropdown'
        },
        {
            title: 'About DSSL',
            children: [
                'Our Story', 'Contact Us'
            ],
            type: 'dropdown'
        },
        {
            title: 'Our Reps',
            url: '/our-reps',
            type: 'single'
        },

    ]

    useEffect(() => {
        if (isCaptchaExpired) setToken(null);
    }, [isCaptchaExpired]);

    const handleSearch = () => {
        let data = isSearch.toLowerCase();
        setShowDiv(false);
        setShow(false);
        isCategory.map((item) => {
            let source = item.attributes.name.toLowerCase();
            if (source.includes(data)) {
                navigate(`/products/category/${item.attributes.name}`)
            }
        })
        isCollection.map((item) => {
            let source = item.attributes.name.toLowerCase();
            if (source.includes(data)) {
                window.localStorage.setItem("category", item.attributes.category.data.attributes.name);
                window.localStorage.setItem("product_name", item.attributes.name);
                navigate('/product-detail')
            }
        })
    }

    const handleSearchInput = (e) => {
        setSearch(e.target.value)
        let data = e.target.value.toLowerCase();
        let option = [];
        isCategory.map((item) => {
            let source = item.attributes.name.toLowerCase();
            if (source.includes(data)) {
                option.push(item.attributes.name);
            }
        })
        isCollection.map((item) => {
            let source = item.attributes.name.toLowerCase();
            if (source.includes(data)) {
                option.push(item.attributes.name);
            }
        })
        if (e.target.value) {
            setOption(option);
            setShowDiv(true);
        } else {
            setShowDiv(false);
        }
    }

    const handleSearchOption = (option) => {
        setSearch(option);
        setShowDiv(false);
        setShow(false);
        isCategory.map((item) => {
            if (item.attributes.name === option) {
                navigate(`/products/category/${item.attributes.name}`)
            }
        })
        isCollection.map((item) => {
            if (item.attributes.name === option) {
                window.localStorage.setItem("category", item.attributes.category.data.attributes.name);
                window.localStorage.setItem("product_name", item.attributes.name);
                navigate('/product-detail')
            }
        })
    }

    const onKeyDownHandler = (e) => {
        if (e.keyCode === 13) {
            handleSearch();
        }
    }

    const handleMenu = () => {
        console.log("handle menu");
        setIsMenu(!isMenu);
    }

    const RequestQuote = () => {
        setShowModal(true)
    }

    const handleVerificationSuccess = token => {
        setToken(token);
        if (token) setIsCaptchaExpired(false);
    };

    const handleEmailSend = () => {
        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
            },
            body: JSON.stringify({
                email: email,
                quote: isQuote
            })
        };

        setIsClicked(true);
        if (!validator.isEmail(email)) {
            setIsEmailError(true);
        } else {
            setIsEmailError(false);
        }

        if (validator.isEmail(email) && token) {
            setIsOpenBackdrop(true);
            fetch(`/api/quote/send`, requestOptions)
                .then(response => {
                    return response.json();
                })
                .then(result => {
                    setIsClicked(false);
                    setEmail("");
                    setToken(null);
                    setQuote("");
                    setIsOpenBackdrop(false);
                    captchaRef.current.resetCaptcha();

                    if (result.status === "success") {
                        Swal.fire("Success!", result.msg, "success");
                    } else {
                        Swal.fire("Oops...", result.msg, "error");
                    }
                }).catch(err => console.log(err));
        }
    };

    return (
        <React.Fragment>

            <div className='header'>
                <nav className='navbar container'>
                    <Link to='/' className='logo'>
                        <img src={logo} alt='logo' />
                    </Link>
                    <ul className='desktop-list list-unstyled'>
                        {
                            navItems.map((item, index) => {
                                switch (item.type) {
                                    case 'dropdown':
                                        return (<li className='dropdown' key={index}>
                                            <Dropdown data={item} setIsMenu={setIsMenu} />
                                        </li>);
                                    case 'single':
                                        return (<li className='dropbtn' key={index}
                                                    onClick={() => navigate(item.url)}
                                        >{item.title}</li>)
                                }

                            })


                        }

                    </ul>
                    <div className='d-flex align-items-center justify-content-center'>
                        <BsList className='mobile-list' onClick={() => handleMenu()} />
                        <div className='d-flex header-button-group' style={{ height: "58px" }}>
                            <button className='quote-item d-flex align-items-center justify-content-center' onClick={() => RequestQuote()}>Request Quote</button>
                            <button className='search-item d-flex align-items-center justify-content-center' onClick={() => { setShow(!isShow); setSearch("") }}>
                                <div>
                                    Search<FiSearch />
                                </div>
                            </button>
                        </div>
                    </div>
                    {
                        isMenu &&
                        <div className='mobile-menu-wrapper'>
                            <ul className='mobile-list-menu list-unstyled'>
                                {
                                    navItems.map((item, index) => {
                                        switch (item.type) {
                                            case 'dropdown':
                                                return (<li className='dropdown' key={index}>
                                                    <Dropdown data={item} setIsMenu={setIsMenu} />
                                                </li>);
                                            case 'single':
                                                return (<li className='dropbtn' key={index}
                                                            onClick={() => { navigate(item.url); setIsMenu(false) }}
                                                >{item.title}</li>)
                                        }

                                    })
                                }
                            </ul>
                        </div>
                    }
                </nav>
                {isShow && <div className='search-input'>
                    <div className="input-group mt-2">
                        <input type="search" className="form-control" value={isSearch} onChange={(e) => handleSearchInput(e)} placeholder="Search by category (eg. INDOOR, OUTDOOR, SPEC LINE) or by family (eg. DXFC,DXR)" aria-label="Search by category (eg. INDOOR, OUTDOOR, SPEC LINE) or by family (eg. DXFC,DXR)" aria-describedby="basic-addon2" onKeyDown={onKeyDownHandler} />
                        <div className="input-group-append">
                            <button className="btn btn-outline-secondary" type="button" onClick={handleSearch}><AiOutlineSearch className='search-button-icon' /></button>
                        </div>
                    </div>
                    {isShowDiv && <div className='search-select'>
                        {isOption.map((item, key) => {
                            if (key < 5) {
                                return <div key={key} className='search-option' onClick={() => handleSearchOption(item)}>{item}</div>
                            }
                        })}
                    </div>}
                </div>}
            </div>
            <Modal
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={isShowModal}
                onHide={() => setShowModal(false)}
            >
                <Modal.Header closeButton>
                    <h5 className="modal-title" id="exampleModalLabel">
                        Specification
                    </h5>
                </Modal.Header>
                <Modal.Body>
                    <form
                        className="form-floating mb-3"
                        id="form"
                        noValidate
                    >
                        <input
                            name="email"
                            type="email"
                            className={`form-control ${isEmailError
                                ? "is-invalid"
                                : isClicked && "is-valid"
                                }`}
                            id="floatingInput"
                            placeholder="name@gmail.com"
                            defaultValue={email}
                            onChange={e => {
                                setEmail(e.target.value);
                            }}
                        />
                        <label htmlFor="floatingInput">Email address</label>
                        {isEmailError ? (
                            <div className="invalid-feedback">
                                Please enter a valid email.
                            </div>
                        ) : (
                            isClicked && (
                                <div className="valid-feedback">
                                    Looks good!
                                </div>
                            )
                        )}
                        <textarea name='quote' className='mt-2' style={{ width: "100%", border: "1px solid #ced4da" }} value={isQuote} onChange={(e) => setQuote(e.target.value)} rows={4}></textarea>
                        <div className="mt-2">
                            <HCaptcha
                                ref={captchaRef}
                                sitekey="8d147cae-36a3-40e9-a9c5-6f5742ce5219"
                                onVerify={token =>
                                    handleVerificationSuccess(token)
                                }
                                onExpire={() => setIsCaptchaExpired(true)}
                            />
                        </div>
                        {!token && isClicked ? (
                            <p className="text-danger">
                                This is hCaptcha for human testing.
                            </p>
                        ) : (
                            isCaptchaExpired && (
                                <p className="text-danger">
                                    The hCaptcha for human testing has expired.
                                </p>
                            )
                        )}
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        onClick={() => setShowModal(false)}
                        className="btn btn-secondary"
                        data-bs-dismiss="modal"
                        id="closeModal"
                    >
                        Close
                    </Button>
                    <Button
                        onClick={() => handleEmailSend()}
                        type="submit"
                        className="btn btn-dark"
                    >
                        Send
                    </Button>
                </Modal.Footer>
            </Modal>
            <Backdrop
                sx={{
                    color: "#fff",
                    zIndex: theme => theme.zIndex.drawer + 1
                }}
                open={isOpenBackdrop}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </React.Fragment>
    )
}

export default Header;
